// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"143c2e71","396":"3bece432","453":"9d88b2d0","455":"06f698df","857":"6ddc4496","977":"e5b92333"}[chunkId] + ".chunk.js";
};